import { Box } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useLocale } from '@koopajs/react';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useAppContext } from '@koopajs/react';
import MoreTimeIcon from '@mui/icons-material/MoreTime';
import { useMultipleDocumentsInMemoryDropzone } from 'components/hooks/useMultipleDocumentsInMemoryDropzone';
interface IUploadMinuteButtonProps {
  isProcessing?: boolean;
  variant?: 'contained' | 'outlined';
  buttonLabel?: string;
}

export const UploadMinuteButton: React.FC<IUploadMinuteButtonProps> = (props) => {
  const { isProcessing: isReloadingMinutes, variant, buttonLabel } = props;
  const { setComponentContext } = useAppContext();

  const { t } = useLocale();
  const history = useHistory();

  const { dropzone, isProcessing, files } = useMultipleDocumentsInMemoryDropzone({
    isStoringFileInMemory: true,
    isMultiple: true
  });

  useEffect(() => {
    if (files) {
      history.push({ pathname: `/uploaded-minutes` });
      setComponentContext('uploadedMinutes', { files });
    }
  }, [JSON.stringify(files)]);

  return (
    <Box {...dropzone.getRootProps()} data-cy="upload-minute-button_container">
      <input {...dropzone.getInputProps()} data-cy="upload-minute-button_input" />

      <LoadingButton
        onClick={dropzone.open}
        startIcon={<MoreTimeIcon />}
        loading={isProcessing}
        loadingPosition="start"
        disabled={isReloadingMinutes}
        variant={variant}
        data-cy="upload-minute-button"
      >
        <span>{buttonLabel ? buttonLabel : t('common:add')}</span>
      </LoadingButton>
    </Box>
  );
};
